module.exports = __webpack_public_path__ + "windows-4a207f9f3082b97f6b6853bd657b9c0f.svg";